import { createAction, props } from '@ngrx/store';

import { DeliveryAsset } from '../../models/delivery-asset.model';
import { Delivery, OfflineDelivery } from '../../models/delivery.model';

const actionKey = '[Offline]';

export const setUserKey = createAction(`${actionKey} Set user key`);

export const saveOfflineDelivery = createAction(
  `${actionKey} Save offline delivery`,
  props<{ delivery: Delivery }>(),
);

export const saveOfflineDeliverySuccess = createAction(
  `${actionKey} Save offline delivery success`,
);
export const saveOfflineDeliveryFail = createAction(
  `${actionKey} Save offline delivery fail`,
  props<{ deliveryKeyCode: string }>(),
);

export const saveAudioAssets = createAction(
  `${actionKey} Save offline assets`,
  props<{ assets: DeliveryAsset[]; deliveryKeyCode: string }>(),
);

export const saveAudioAssetsSuccess = createAction(`${actionKey} Save offline assets success`);
export const saveAudioAssetsFail = createAction(`${actionKey} Save assets delivery fail`);

export const getDeliveriesAudioAssets = createAction(
  `${actionKey} get deliveries audio assets`,
  props<{ deliveryKeyCode: string }>(),
);

export const getDeliveriesAudioAssetsSuccess = createAction(
  `${actionKey} get deliveries assets audio success`,
  props<{ assets: DeliveryAsset[]; deliveryKeyCode: string }>(),
);

export const getDeliveriesAudioAssetsFail = createAction(
  `${actionKey} get deliveries assets audio fail`,
  props<{ deliveryKeyCode: string }>(),
);

export const refreshOfflineDeliveryAfterLogin = createAction(
  `${actionKey} refresh offline delivery after login`,
  props<{ deliveries: OfflineDelivery[] }>(),
);

export const refreshOfflineDelivery = createAction(`${actionKey} refresh offline delivery`);
export const refreshOfflineDeliverySuccess = createAction(
  `${actionKey} refresh offline delivery success`,
  props<{ deliveries: any }>(),
);

export const refreshOfflineDeliveryFail = createAction(
  `${actionKey} refresh offline delivery fail`,
  props<{ error: any }>(),
);

export const refreshDownloading = createAction(
  `${actionKey} refresh downloading delivery`,
  props<{ deliveryKeyCode: string }>(),
);

export const refreshDownloadingSuccess = createAction(
  `${actionKey}  refresh downloading delivery success`,
  props<{ deliveries: OfflineDelivery[] }>(),
);

export const refreshDownloadingFail = createAction(
  `${actionKey}  refresh downloading delivery fail`,
);

export const stopDownloading = createAction(`${actionKey} stop delivery downloading`);

export const stopDownloadingSuccess = createAction(
  `${actionKey}  stop delivery downloading success`,
  props<{ deliveries: OfflineDelivery[] }>(),
);

export const stopDownloadingDownloadingFail = createAction(
  `${actionKey}  stop delivery downloading fail`,
);

export const downloadDeliveryImage = createAction(
  `${actionKey} Download Delivery Image`,
  props<{ url: string; fieldName: string; deliveryKeyCode: string }>(),
);

export const downloadDeliveryImageSuccess = createAction(
  `${actionKey} Download Delivery Image success`,
  props<{ deliveryKeyCode: string; fieldName: string }>(),
);

export const downloadDeliveryImageFail = createAction(`${actionKey} Download Delivery Image fial `);

export const storeDeliveryImageSuccess = createAction(
  `${actionKey} Store Delivery Image success`,
  props<{ deliveryKeyCode: string; localUrl: string; fieldName: string }>(),
);

export const storeDeliveryImageFail = createAction(`${actionKey} Store Delivery Image fial `);

export const downloadAudioAsset = createAction(
  `${actionKey} Download audio asset`,
  props<{ asset: DeliveryAsset }>(),
);
export const downloadAudioAssetSuccess = createAction(`${actionKey} Download audio asset success`);
export const downloadAudioAssetFail = createAction(
  `${actionKey} Download audio asset fail`,
  props<{ deliveryKeyCode?: string; error: any }>(),
);

export const removeOfflineDelivery = createAction(
  `${actionKey} Remove Offline Item`,
  props<{ deliveryKeyCode: string }>(),
);

export const removeOfflineDeliverySuccess = createAction(
  `${actionKey} Remove Offline Item success`,
);

export const removeOfflineDeliveryFail = createAction(`${actionKey} Remove Offline Item fail`);

export const offlineItemsRequestFailed = createAction(
  `${actionKey} Offline Items Request Failed`,
  props<{ error: any }>(),
);

export const setOfflineState = createAction(
  `${actionKey} Set Offline State`,
  props<{ isOffline: boolean }>(),
);

export const offlineStreamPlay = createAction(
  `${actionKey} Offline Stream Play`,
  props<{ deliveryKeyCode: string; assetKeyCode: string; assetName: string }>(),
);

export const writeToAudioFile = createAction(
  `${actionKey} Write to file`,
  props<{ file: Blob; asset: DeliveryAsset }>(),
);

export const writeToAudioFileSuccess = createAction(
  `${actionKey} Write to audio file success`,
  props<{ asset: DeliveryAsset }>(),
);

export const writeToAudioFileFail = createAction(`${actionKey} Write to file fail`);

export const cancelDownloading = createAction(
  `${actionKey} Cancel downloading`,
  props<{ deliveryKeyCode: string }>(),
);

export const downloadRestAfterOfflineMode = createAction(
  `${actionKey} download rest assets after offline mode`,
);

export const updateOfflineAsset = createAction(
  `${actionKey} update offline asset`,
  props<{ asset: DeliveryAsset }>(),
);
export const updateOfflineAssetSuccess = createAction(`${actionKey} update offline asset success`);
export const updateOfflineAssetFail = createAction(`${actionKey} update offline asset fail`);

export const updateOfflineDeliveries = createAction(`${actionKey} update offline deliveries`);
export const updateOfflineDeliveriesSuccess = createAction(
  `${actionKey} update offline deliveries success`,
);
export const updateOfflineDeliveriesFail = createAction(
  `${actionKey} update offline deliveries fail`,
);

export const setOfflineOptions = createAction(
  `${actionKey} set offline options`,
  props<{ options: any }>(),
);

export const setNetworkType = createAction(
  `${actionKey} set network type`,
  props<{ networkType: string }>(),
);

export const clearAllCache = createAction(`${actionKey} clearAllCache`);
export const clearAllCacheSuccess = createAction(`${actionKey} clearAllCache success`);
export const clearAllCacheFail = createAction(`${actionKey} clearAllCache fail`);

export const setBasePath = createAction(`${actionKey} set base path`);
export const setBasePathSuccess = createAction(
  `${actionKey} set base path success`,
  props<{ basePath: string }>(),
);
export const setBasePathFail = createAction(`${actionKey} set base path fail`);

export const refreshDeliveriesFromStore = createAction(`${actionKey} refresh delivery from store`);

export const updateDeliveryFromServer = createAction(
  `${actionKey} update delivery from server`,
  props<{ deliveryKeyCode: string }>(),
);
export const updateDeliveryFromServerSuccess = createAction(
  `${actionKey} update delivery from server success`,
  props<{ delivery: Delivery }>(),
);
export const updateDeliveryFromServerFail = createAction(
  `${actionKey} update delivery from server fail`,
);
export const updateOfflineDownloadingState = createAction(
  `${actionKey} update offline downloading state`,
  props<{ isDownloading: boolean }>(),
);
